"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importDefault(require("react"));
const assets_1 = require("~/assets");
const Checkbox_scss_1 = __importDefault(require("./Checkbox.scss"));
function Checkbox({ checked = false, label, disabled = false, onCheck = () => {
    /* do nothing */
}, }) {
    const clickHandler = () => {
        if (!disabled) {
            onCheck(!checked);
        }
    };
    const activeIcon = disabled ? assets_1.svgSystemCheckboxDisabledActive : assets_1.svgSystemCheckboxEnabledActive;
    const inactiveIcon = disabled ? assets_1.svgSystemCheckboxDisabledInactive : assets_1.svgSystemCheckboxEnabledInactive;
    return (react_1.default.createElement("button", { type: "button", role: "checkbox", className: Checkbox_scss_1.default['checkbox'], onClick: clickHandler, "aria-checked": checked, tabIndex: disabled ? -1 : 0 },
        react_1.default.createElement("img", { src: checked ? activeIcon : inactiveIcon }),
        " ",
        react_1.default.createElement("span", { className: disabled ? Checkbox_scss_1.default.disabled : '' }, label)));
}
exports.default = Checkbox;
